import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'react-bootstrap';
import { getNCFrameSummary } from 'services/productionOverviewService';
import { getRightFirstTimePercent, mapCheckedGroups } from './qualitySummaryHelpers';
import QualitySummaryCard from './QualitySummaryCard';

export default function QualityCheckedSummary({ date }) {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    getNCFrameSummary(date, date)
      .then(result => {
        if (cancelled) return;
        const data = result?.data?.data || result?.data || {};
        setGroups(Array.isArray(data.groups) ? data.groups : []);
      })
      .catch(err => {
        if (!cancelled) console.error('Error fetching N/C frame summary', err);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [date]);

  const cards = useMemo(
    () =>
      mapCheckedGroups(groups).map(item => ({
        ...item,
        rftPercent: getRightFirstTimePercent(item.totalChecked, item.totalRejected)
      })),
    [groups]
  );

  return (
    <section className="quality-summary-section" style={{ marginTop: 20 }}>
      <h4 className="quality-summary-section-title" style={{ margin: '0 0 10px', fontSize: 15, fontWeight: 700 }}>
        Checked Summary — Frames N/C, Ancillary, Hardware, Welded Cills
      </h4>

      {loading ? (
        <div className="text-center py-3">
          <Spinner variant="primary" animation="border" role="status" />
        </div>
      ) : cards.length > 0 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 12 }}>
          {cards.map(c => (
            <QualitySummaryCard
              key={c.key}
              label={c.label}
              rftPercent={c.rftPercent}
              stats={[
                { label: 'To Check', value: c.totalToCheck },
                { label: 'Checked', value: c.totalChecked },
                { label: 'Rejected', value: c.totalRejected }
              ]}
            />
          ))}
        </div>
      ) : (
        <div className="quality-summary-status" style={{ fontSize: 13 }}>
          No checked summary data for this date.
        </div>
      )}
    </section>
  );
}

QualityCheckedSummary.propTypes = {
  date: PropTypes.string.isRequired
};
